// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-4a075211]{width:100%;color:#fff;fill:currentColor;stroke:none}", ""]);
// Exports
module.exports = exports;
